import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { ButtonValidate } from "../../../components/common/ButtonValidate";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	exerciseKeyboardOne: 3,
	winExerciseKeyboardOne: 4,
	failExerciseKeyboardOne: 5,
	netoChatOne: 6,
	clientChatOne: 7,
	netoChatTwo: 8,
	showMonitorOne: 9,
	dialogTwo: 10,
	dialogThree: 11,
	exerciseKeyboardTwo: 12,
	winExerciseKeyboardTwo: 13,
	failExerciseKeyboardTwo: 14,
	netoChatThree: 15,
	clientChatTwo: 16,
	netoChatFour: 17,
	clientChatThree: 18,
	dialogFour: 19,
	dialogFive: 20,
	exerciseKeyboardThree: 21,
	winExerciseKeyboardThree: 22,
	failExerciseKeyboardThree: 23,
	clientInsertCard: 24,
	netoCardChatOne: 25,
	clientCardChatOne: 26,
	netoCardChatTwo: 27,
	netoChatFive: 28,
	clientChatFour: 29,
	netoChatSix: 30,
	dialogSix: 31,
	hideUI: 100,
}
let numberSumPoint = 0
export const Tema4SubtopicFourActivityFive = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema4], 5);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema4 activity 5");
			ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 5);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a01)
	})
	ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.validateQuizOne, (status) => {
		if (status) {
			setUiToShow(steps.winExerciseKeyboardOne)
		} else {
			setUiToShow(steps.failExerciseKeyboardOne)
		}
	})
	ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.validateQuizTwo, (status) => {
		if (status) {
			setUiToShow(steps.winExerciseKeyboardTwo)
		} else {
			setUiToShow(steps.failExerciseKeyboardTwo)
		}
	})
	ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.validateQuizThree, (status) => {
		if (status) {
			setUiToShow(steps.winExerciseKeyboardThree)
		} else {
			setUiToShow(steps.failExerciseKeyboardThree)
		}
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 3, 12, 21, 24, 25, 26, 27, 100].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 5);
						numberSumPoint = 0
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.hideUI && (
				<>
				</>
			)}
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Ejercicio: Atajos de teclado" />
					<DialogBarNew
						dialog={
							"¿Cuál tecla debes presionar para cancelar un producto? Selecciona la que consideres adecuada haciendo clic en ella."
						}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.characterAnimations.idle)
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 4: Cobro de productos"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.moveCameraOverKeyboard)
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.quizOne)

							setUiToShow(steps.exerciseKeyboardOne);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.exerciseKeyboardOne && (
				<>
					<BarStatusActivies activities={tasksList} />
					<ButtonValidate
						name="Responder"
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.respondQuizOne)
						}}
					>
					</ButtonValidate>
				</>
			)}
			{uiToShow === steps.winExerciseKeyboardOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={20}
						dialogModal="Lograste identificar el atajo de teclado correcto. Eres muy hábil para trabajar ágilmente con tus herramientas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							numberSumPoint += 20
							setUiToShow(steps.netoChatOne)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a02)
						}}
					/>
				</>
			)}
			{uiToShow === steps.failExerciseKeyboardOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={10}
						dialogModal="¡Ánimo! Recuerda que es importante conocer los atajos de teclado."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							numberSumPoint += 10
							setUiToShow(steps.netoChatOne)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a02)
						}}
					/>
				</>
			)}
			{uiToShow === steps.netoChatOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"¿Algo más?"
						}
						callback={() => {
							setUiToShow(steps.clientChatOne);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a03)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.amandaWithHotDog} alt="Amanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Amanda"
						dialog={
							"Si, me estaría llevando esto."
						}
						callback={() => {
							setUiToShow(steps.netoChatTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a04)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Muy bien, empiezo a marcar."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.showMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.img4monitor);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.showMonitorOne);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.showMonitorOne && (
				<>
					<DialogBarNew
						name="Neto"
						dialog={
							"Muy bien, empiezo a marcar."
						}
						callback={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a05)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"Recuerda que para marcar los alimentos de Food Service, puedes usar un atajo de teclado o en Alimentos en la pantalla e identificar el producto."
						}
						callback={() => {
							setUiToShow(steps.dialogThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a06)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<HeaderRedPresentation name="Ejercicio: Atajos de teclado" />
					<DialogBarNew
						dialog={
							"Selecciona la tecla que consideres adecuada para Food Service, haciendo clic en ella."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.moveCameraOverKeyboard)
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.quizTwo)
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.exerciseKeyboardTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.exerciseKeyboardTwo && (
				<>
					<ButtonValidate
						name="Responder"
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.respondQuizTwo)
						}}
					>
					</ButtonValidate>
				</>
			)}
			{uiToShow === steps.winExerciseKeyboardTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={20}
						dialogModal="Lograste identificar el atajo de teclado correcto. Eres muy hábil para trabajar ágilmente con tus herramientas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							numberSumPoint += 20
							setUiToShow(steps.netoChatThree)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a07)
						}}
					/>
				</>
			)}
			{uiToShow === steps.failExerciseKeyboardTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={10}
						dialogModal="¡Ánimo! Recuerda que es importante conocer los atajos de teclado."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							numberSumPoint += 10
							setUiToShow(steps.netoChatThree)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a07)
						}}
					/>
				</>
			)}
			{uiToShow === steps.netoChatThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.netoWithCoke} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"¿Quiere llevarse una Coca Cola para acompañar su compra?"
						}
						callback={() => {
							setUiToShow(steps.clientChatTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a08)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.amanda} alt="Amanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Amanda"
						dialog={
							"No gracias."
						}
						callback={() => {
							setUiToShow(steps.netoChatFour);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a09)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Serian $32 pesos, ¿pago en efectivo o con tarjeta?"
						}
						callback={() => {
							setUiToShow(steps.clientChatThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a10)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.amandaWithCard} alt="Amanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Amanda"
						dialog={
							"Tarjeta."
						}
						callback={() => {
							setUiToShow(steps.dialogFour);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a11)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={
							"Con la información proporcionada por el cliente ¿Qué acción debes realizar?"
						}
						callback={() => {
							setUiToShow(steps.dialogFive);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a12)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFive && (
				<>
					<HeaderRedPresentation name="Ejercicio: Atajos de teclado" />
					<DialogBarNew
						dialog={
							"Selecciona la tecla que consideres adecuada haciendo clic en ella."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.moveCameraOverKeyboard)
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.quizThree)
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.exerciseKeyboardThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.exerciseKeyboardThree && (
				<>
					<ButtonValidate
						name="Responder"
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.respondQuizThree)
						}}
					>
					</ButtonValidate>
				</>
			)}
			{uiToShow === steps.winExerciseKeyboardThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={20}
						dialogModal="Lograste identificar el atajo de teclado correcto. Eres muy hábil para trabajar ágilmente con tus herramientas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 5,
									pointsWin: numberSumPoint + 20,
									subtema: tasksId.tema4.activities.subtema4,
								})
							);
							setUiToShow(steps.clientInsertCard)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel)
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.showPinPad)
						}}
					/>
				</>
			)}
			{uiToShow === steps.failExerciseKeyboardThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={10}
						dialogModal="¡Ánimo! Recuerda que es importante conocer los atajos de teclado."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 5,
									pointsWin: numberSumPoint + 10,
									subtema: tasksId.tema4.activities.subtema4,
								})
							);
							setUiToShow(steps.clientInsertCard)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel)
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.showPinPad)
						}}
					/>
				</>
			)}
			{uiToShow === steps.clientInsertCard && (
				<>
					<DialogBarNew
						dialog={
							"Ahora el cliente insertara su tarjeta"
						}
						callback={() => {
							setUiToShow(steps.hideUI);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.insertCard)
							setTimeout(() => {
								setUiToShow(steps.netoCardChatOne);
								ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a13)
							}, 4000);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoCardChatOne && (
				<>
					<DialogBarNew
						name="Neto"
						dialog={
							"Puede ingresar su NIP, por favor."
						}
						callback={() => {
							setUiToShow(steps.clientCardChatOne);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a14)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientCardChatOne && (
				<>
					<DialogBarNew
						name="Amanda"
						dialog={
							"Sí."
						}
						callback={() => {
							setUiToShow(steps.netoCardChatTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a15)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoCardChatTwo && (
				<>
					<DialogBarNew
						name="Neto"
						dialog={
							"Ya puede retirar su tarjeta."
						}
						callback={() => {
							setUiToShow(steps.hideUI);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.removeCard)
							setTimeout(() => {
								ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
								ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a16)
								setUiToShow(steps.netoChatFive);
							}, 3000);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatFive && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.netoWithTicket} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Y aquí tiene su ticket."
						}
						callback={() => {
							setUiToShow(steps.clientChatFour);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a17)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.amanda} alt="Amanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Amanda"
						dialog={
							"Gracias."
						}
						callback={() => {
							setUiToShow(steps.netoChatSix);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a18)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatSix && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"A usted que tenga buen día. Regrese pronto."
						}
						callback={() => {
							setUiToShow(steps.dialogSix);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act5_a19)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={
							"Lo hiciste muy bien, Felicidades."
						}
						callback={() => {
							navigation("/home4/tema4/subtema4/results");
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}

		</>
	)
}
